import Link from './link';

export default {
  tag: 'a',
  format: `[text](url)`,
  sourcePipeline: (source: string) => source,
  componentFn: (node: any) => {
    return <Link node={node} />;
  }
};
